import { History } from 'history';

export const navigateBack = (history: History<unknown>): void => {
  if (history.length > 2) {
    return history.goBack();
  }
  return history.push('/portfolio');
};
